import { compose } from "redux";
import Highcharts from "highcharts";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import People from "@material-ui/icons/People";
import { Grid, Typography, Paper } from "@material-ui/core";

import { withToggleModal } from "altus-ui-components";

import {
  EMPLOYEE_TYPES,
  CARD_CONTAINER_TYPE,
  DASHBOARD_EMPLOYEES_MODAL,
} from "features/planner/planner.constants";

import { APP_ROLES } from "app/app.constants";
import DefaultChart from "app/components/Chart/DefaultChart";
import { cardContainerTypeToString } from "features/planner/planner.mappers";
import DashboardTile from "features/planner/report/dashboard/components/DashboardTile";
import { getEmployeesByEmployeeTypeAndCardContainerType } from "features/planner/report/report.actions";

class DeploymentsDashboardSection extends PureComponent {
  toggleModal = () => {
    const { dispatchToggleModal } = this.props;

    dispatchToggleModal({
      modalId: DASHBOARD_EMPLOYEES_MODAL,
    });
  };

  getEmployeesByEmployeeTypeAndCardContainerTypeThenToggleModal = ({
    title,
    employeeType,
    cardContainerType,
  }) => {
    const {
      setModalTitle,
      dispatchGetEmployeesByEmployeeTypeAndCardContainerType,
    } = this.props;

    return dispatchGetEmployeesByEmployeeTypeAndCardContainerType(
      employeeType,
      cardContainerType,
    )
      .then(() => setModalTitle(title))
      .then(this.toggleModal);
  };

  render() {
    const { stats } = this.props;

    const personnelOffshoreByCrew = stats.get("personnelOffshoreByCrew");

    return (
      <Grid container spacing={1}>
        <Grid container item>
          <Typography variant="h6">Deployment status</Typography>
        </Grid>

        <Grid container item spacing={2}>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "employeesCountByCardContainerType",
                CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE.toString(),
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getEmployeesByEmployeeTypeAndCardContainerTypeThenToggleModal(
                    {
                      employeeType: EMPLOYEE_TYPES.EMPLOYEE,
                      cardContainerType: CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                      title: `Altus personnel - ${cardContainerTypeToString(
                        CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                      )}`,
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Altus personnel
                <br />
                <b>
                  {cardContainerTypeToString(
                    CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                  )}
                </b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "employeesCountByCardContainerType",
                CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE.toString(),
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getEmployeesByEmployeeTypeAndCardContainerTypeThenToggleModal(
                    {
                      employeeType: EMPLOYEE_TYPES.EMPLOYEE,
                      cardContainerType: CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                      title: `Altus personnel - ${cardContainerTypeToString(
                        CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                      )}`,
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Altus personnel
                <br />
                <b>
                  {cardContainerTypeToString(
                    CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                  )}
                </b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "subContractorsCountByCardContainerType",
                CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE.toString(),
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getEmployeesByEmployeeTypeAndCardContainerTypeThenToggleModal(
                    {
                      employeeType: EMPLOYEE_TYPES.SUB_CONTRACTOR,
                      cardContainerType: CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                      title: `Sub Contractors - ${cardContainerTypeToString(
                        CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                      )}`,
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Sub Contractors
                <br />
                <b>
                  {cardContainerTypeToString(
                    CARD_CONTAINER_TYPE.DEPLOYED_OFFSHORE,
                  )}
                </b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6} xl={3}>
            <DashboardTile
              chipLabel={stats.getIn([
                "subContractorsCountByCardContainerType",
                CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE.toString(),
              ])}
              ActionButtonProps={{
                title: "Show employees",
                onClick: () =>
                  this.getEmployeesByEmployeeTypeAndCardContainerTypeThenToggleModal(
                    {
                      employeeType: EMPLOYEE_TYPES.SUB_CONTRACTOR,
                      cardContainerType: CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                      title: `Sub Contractors - ${cardContainerTypeToString(
                        CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                      )}`,
                    },
                  ),
                renderIcon: () => <People />,
                accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
              }}
            >
              <Typography variant="body2" align="center">
                Sub Contractors
                <br />
                <b>
                  {cardContainerTypeToString(
                    CARD_CONTAINER_TYPE.ALLOCATED_OFFSHORE,
                  )}
                </b>
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6}>
            <DashboardTile
              chipLabel={stats.get("locationsWithEmployeesDeployedCount")}
            >
              <Typography variant="body2" align="center">
                Locations with Altus personnel deployed
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={6}>
            <DashboardTile
              chipLabel={stats.get("locationsWithSubContractorsDeployedCount")}
            >
              <Typography variant="body2" align="center">
                Locations with Sub Contractors deployed
              </Typography>
            </DashboardTile>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={1}>
              <DefaultChart
                options={{
                  lang: {
                    noData: "No personnel offshore",
                  },
                  chart: {
                    type: "column",
                  },
                  subtitle: {
                    text: "Total personnel offshore - by Crew",
                  },
                  yAxis: {
                    title: {
                      text: "Total",
                    },
                    stackLabels: {
                      enabled: true,
                      style: {
                        fontWeight: "bold",
                        color: Highcharts.defaultOptions.title.style.color,
                      },
                    },
                  },
                  tooltip: {
                    pointFormat:
                      "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
                  },
                  xAxis: {
                    categories: personnelOffshoreByCrew
                      ? personnelOffshoreByCrew.categories
                      : [],
                  },
                  series: personnelOffshoreByCrew
                    ? personnelOffshoreByCrew.series
                    : [],
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  connect(null, {
    dispatchGetEmployeesByEmployeeTypeAndCardContainerType: getEmployeesByEmployeeTypeAndCardContainerType,
  }),
  withToggleModal,
)(DeploymentsDashboardSection);
